import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import Event from "@/services/Event";
import store from "@/store/store";
import VueCurrencyFilter from "vue-currency-filter";
import VueGlobalVariable from "vue-global-var";
import JsonExcel from "vue-json-excel";
import Loading from "vue-loading-overlay";
import Vuetify, { VLayout } from "vuetify/lib";
import { chrome } from "vue-color";
import "froala-editor/css/froala_editor.pkgd.min.css";
import VueFroala from "vue-froala-wysiwyg";
import Api from "@/services/Api";
import "vue-loaders/dist/vue-loaders.css";
import VueLoaders from "vue-loaders";
import VueClipboard from "vue-clipboard2";
import VueResizeText from "vue-resize-text";
import JsonCSV from "vue-json-csv";
import VueHtmlToPaper from "vue-html-to-paper";
import VCalendar from "v-calendar";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import VueDragDrop from "vue-drag-drop";
import io from "socket.io-client";
import config from "../../config/config.json";
import * as VueGoogleMaps from "vue2-google-maps";
import VueFab from "vue-float-action-button";
import Chartkick from "vue-chartkick";
import Chart from "chart.js";
import GmapCluster from "vue2-google-maps/dist/components/cluster";
import fullscreen from "vue-fullscreen";
import VueCroppie from "vue-croppie";
import "croppie/croppie.css";
import VueKonva from "vue-konva";
import VueGoogleCharts from "vue-google-charts";
import VueSimpleMarkdown from "vue-simple-markdown";
// You need a specific loader for CSS files like https://github.com/webpack/css-loader
import "vue-simple-markdown/dist/vue-simple-markdown.css";
import wysiwyg from "vue-wysiwyg";
import "vue-wysiwyg/dist/vueWysiwyg.css";
import VueAtTextarea from "vue-at-textarea";
import VueExcelXlsx from "vue-excel-xlsx";
Vue.use(VueAtTextarea);
Vue.use(wysiwyg, {
  hideModules: { image: true },
});
Vue.use(VueSimpleMarkdown);
Vue.use(VueExcelXlsx);
Vue.use(VueGoogleCharts);

Vue.use(VueKonva);

Vue.use(VueCroppie);

Vue.component("cluster", GmapCluster);

Vue.use(fullscreen);

Vue.use(VueFab, {
  iconType: "MaterialDesign",
});
Vue.use(Chartkick.use(Chart));
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyADUAGvoETQOOlTLBkW6UEwAJUemn8vg0w",
    libraries: "places,drawing, visualization, geometry",
    installComponents: true,
  },
}),
  Vue.component(
    "ground-overlay",
    VueGoogleMaps.MapElementFactory({
      mappedProps: {
        opacity: {},
      },
      props: {
        source: { type: String },
        bounds: { type: Object },
      },
      events: ["click", "dblclick"],
      name: "groundOverlay",
      ctr: () => google.maps.GroundOverlay,
      ctrArgs: (options, { source, bounds }) => [source, bounds, options],
    })
  );

let websocketServer = "";
let oneSignalAppId = "";
let allowLocalhostAsSecureOrigin = true;
// if(process.env.NODE_ENV==='production'){
//   Vue.config.productionTip = false
//   websocketServer = config.prodWebsocketClient
//   oneSignalAppId = "5109a424-13ba-4ea8-89f6-56db71da4779"
//   allowLocalhostAsSecureOrigin = false
// } else if(process.env.NODE_ENV==='staging'){
//   websocketServer = config.stagingWebsocketClient
//   oneSignalAppId = "fe93f02a-edd4-421d-8980-b3dee1ba67e1"
//   allowLocalhostAsSecureOrigin = false
// } else if(process.env.NODE_ENV==='development'){
//   websocketServer = '127.0.0.1:9000'
//   // oneSignalAppId = "8f9b3c8a-d5d1-461b-8d0f-e54a6055f5b9"
//   // oneSignalAppId = "92749541-1e22-43a7-974a-5d1b0779548a"
// }

// if(process.env.NODE_ENV!=='development'){
//   window.OneSignal = window.OneSignal || [];
// window.OneSignal.push(() => {
//   window.OneSignal.init({
//     appId: oneSignalAppId,
//     notifyButton: {
//       enable: true,
//     },
//     allowLocalhostAsSecureOrigin: true,
//   });
// });
// }

Vue.component("downloadCsv", JsonCSV);
const options = {
  name: "_blank",
  specs: ["fullscreen=yes"],
};

Vue.use(VueDragDrop);
Vue.use(VueCtkDateTimePicker);
Vue.use(VCalendar);
Vue.use(VueResizeText);
Vue.use(VueHtmlToPaper, options);
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

Vue.prototype.$eventSignal = Event;
Vue.use(VueFroala);
Vue.use(VueLoaders);
Vue.component("chromepicker", chrome);

Vue.component("downloadExcel", JsonExcel);
import VueFilterDateFormat from "vue-filter-date-format";
import "./registerServiceWorker";

Vue.use(VueCurrencyFilter, {
  symbol: "R",
  thousandsSeparator: ",",
  fractionCount: 2,
  fractionSeparator: ".",
  symbolPosition: "front",
  symbolSpacing: true,
});

Vue.use(Vuetify, {
  components: {
    VLayout,
  },
});

Vue.use(
  Loading,
  {
    color: "grey",
    loader: "bars",
    width: 64,
    height: 64,
    backgroundColor: "#ffffff",
    opacity: 0.5,
  },
  {}
);

Vue.component("rows-per-page", [10, 20, 50, 100, 500]);

Vue.use(VueFilterDateFormat);

const VAT = 0.15;

Vue.use(VueGlobalVariable, {
  globals: {
    VAT: 0.15,
    socket: io.connect(websocketServer),
  },
});

Vue.config.silent = true;

Vue.mixin({
  methods: {
    authRead(state) {
      let path = this.$route.path;
      if (this.$route.matched.length > 0) {
        path = this.$route.matched[0].path;
      }
      if (state.read && path === state.url) {
        return true;
      } else {
        this.$router.push({ name: "SplashPage" });
        return false;
      }
    },
    authCreate(state) {
      let path = this.$route.path;
      if (this.$route.matched.length > 0) {
        path = this.$route.matched[0].path;
      }
      if (state.create && path === state.url) {
        return true;
      } else {
        confirm(
          "You do not have permission to add items in this module. Please contact your Organisation Administrator for further assistance."
        );
        return false;
      }
    },
    authUpdate(state) {
      let path = this.$route.path;
      if (this.$route.matched.length > 0) {
        path = this.$route.matched[0].path;
      }
      if (state.update && path === state.url) {
        return true;
      } else {
        confirm(
          "You do not have permission to edit items in this module. Please contact your Organisation Administrator for further assistance."
        );
        return false;
      }
    },
    authDelete(state) {
      let path = this.$route.path;
      if (this.$route.matched.length > 0) {
        path = this.$route.matched[0].path;
      }
      if (state.delete && path === state.url) {
        return true;
      } else {
        confirm(
          "You do not have permission to delete items in this module. Please contact your Organisation Administrator for further assistance."
        );
        return false;
      }
    },
    authAdmin(state) {
      let path = this.$route.path;
      if (this.$route.matched.length > 0) {
        path = this.$route.matched[0].path;
      }
      if (state.admin && path === state.url) {
        return true;
      } else {
        // confirm("You do not have permission to delete items in this module. Please contact your Organisation Administrator for further assistance.")
        return false;
      }
    },
    async authenticateSystemAdmin(user) {
      await Api()
        .get("/authenticate/email/" + user.emailAddress)
        .then((response) => {
          if (response.data.auth === true) {
            return true;
          } else {
            return false;
          }
        })
        .catch((error) => {
          return false;
        });
    },
    async authenticateOrganisationAdmin() {
      if (this.$store.state.currentOrg.userType === "organisationAdmin") {
        return true;
      } else {
        return false;
      }
    },
  },
});

new Vue({
  router,
  VAT,
  store,
  render: (h) => h(App),
}).$mount("#app");
